export default "__VITE_PUBLIC_ASSET__e6cc375e__"